<template>
  <section>
    <v-data-table
      class="transparent"
      :headers="headers"
      :items="preregistros"
    >
      <template #[`item.acciones`]="{ item }">
        <v-btn
          color="secondary"
          icon
          @click="openDetallePersonaDialog(item)"
        >
          <v-icon dark>
            mdi-information
          </v-icon>
        </v-btn>
        <v-btn
          color="secondary"
          icon
          @click="openDocumentosDialog(item)"
        >
          <v-icon dark>
            mdi-file-multiple
          </v-icon>
        </v-btn>
        <v-btn
          color="secondary"
          icon
          @click="openEstudiosDialog(item)"
        >
          <v-icon dark>
            mdi-school
          </v-icon>
        </v-btn>
        <v-btn
          color="secondary"
          icon
          @click="openReferenciasDialog(item)"
        >
          <v-icon dark>
            mdi-crowd
          </v-icon>
        </v-btn>
        <v-btn
          color="secondary"
          icon
          @click="openCrearExpedienteDialog(item)"
        >
          <v-icon dark>
            mdi-folder-plus
          </v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <CrearExpedienteDialog
      :active.sync="isDialogActive"
      :preregistro="selectedPreregistro"
      @update:active="closeDialog()"
    />
    <DocumentosDialog
      :active.sync="isDocumentosDialogActive"
      :documentos="documentos"
      @update:active="closeDocumentosDialog()"
    />
  </section>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import createPersonaApiRepository from '../../modules/persona/infrastructure/PersonaApiRepository';
import CrearExpedienteDialog from './CrearExpedienteDialog.vue';
import DocumentosDialog from './DocumentosDialog.vue';
import DIALOG_TYPES from '../../helpers/dialog-types';

export default {
  components: {
    CrearExpedienteDialog,
    DocumentosDialog,
  },

  props: {
    preregistros: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      isDialogActive: false,
      selectedPreregistro: null,
      headers: [
        {
          text: 'Nombre',
          align: 'start',
          value: 'nombre',
        },
        {
          text: 'Segundo nombre',
          align: 'start',
          value: 'segundo_nombre',
        },
        {
          text: 'Apellido paterno',
          align: 'start',
          value: 'apaterno',
        },
        {
          text: 'Apellido materno',
          align: 'start',
          value: 'amaterno',
        },
        {
          text: 'CURP',
          align: 'start',
          value: 'curp',
        },
        {
          text: 'CUIP',
          align: 'start',
          value: 'cuip',
        },
        {
          text: 'Acciones',
          align: 'start',
          value: 'acciones',
        },
      ],

      isDocumentosDialogActive: false,
      documentos: [],
      isDetallePersonaDialogActive: false,
    };
  },

  methods: {
    ...mapActions('dialog', ['setDialog']),
    ...mapMutations('preregistro', ['SET_PREREGISTRO', 'SET_ESTUDIOS', 'SET_REFERENCIAS']),

    openCrearExpedienteDialog(preregistro) {
      this.selectedPreregistro = preregistro;
      this.isDialogActive = true;
    },

    closeDialog() {
      this.isDialogActive = false;
      this.selectedPreregistro = null;
    },

    async openDocumentosDialog(preregistro) {
      const repository = createPersonaApiRepository();
      this.documentos = await repository.getDocumentosByPersona(preregistro.id);
      this.isDocumentosDialogActive = true;
    },

    closeDocumentosDialog() {
      this.isDocumentosDialogActive = false;
      this.selectedPreregistro = null;
    },

    openDetallePersonaDialog(preregistro) {
      this.SET_PREREGISTRO(preregistro);
      this.setDialog(DIALOG_TYPES.DETALLE_PREREGISTRO);
    },

    async openEstudiosDialog(preregistro) {
      const repository = createPersonaApiRepository();
      const estudios = await repository.getEstudiosByPersona(preregistro.id);
      this.SET_ESTUDIOS(estudios);
      this.setDialog(DIALOG_TYPES.ESTUDIOS_PREREGISTRO);
    },

    async openReferenciasDialog(preregistro) {
      const repository = createPersonaApiRepository();
      const referencias = await repository.getReferenciasByPersona(preregistro.id);
      this.SET_REFERENCIAS(referencias);
      this.setDialog(DIALOG_TYPES.REFERENCIAS_PREREGISTRO);
    },
  },
};
</script>
